import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Box,
} from "@chakra-ui/react";
import PrimaryText from "../../../components/PrimaryText";
import FormInput from "../../../components/FormInput";

const PreIntimationModal = ({
  isOpen,
  onClose,
  patientMovingFrom,
  ArrivalWithin,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="primary.1" textAlign={"center"} fontSize={"2xl"}>
          Pre-Intimation Details
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box mt="10px">
            <PrimaryText fontWeight="bold">Patient Moving From</PrimaryText>
            <FormInput
              name="patientMovingFrom"
              value={patientMovingFrom}
              isReadOnly={true}
              variant="filled"
            />
          </Box>
          <Box>
            <PrimaryText fontWeight="bold">Airlines Detail</PrimaryText>
            <FormInput
              name="ArrivalWithin"
              value={ArrivalWithin}
              isReadOnly={true}
              variant="filled"
            />
          </Box>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PreIntimationModal;
